var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_7999",
    "data-name": "Group 7999",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36.116,
    height: 24,
    viewBox: "0 0 36.116 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8000",
    "data-name": "Group 8000",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27020",
    "data-name": "Path 27020",
    d: "M25.92,0c-2.961,0-5.276,2.23-7.372,5.064C15.668,1.4,13.26,0,10.378,0,4.5,0,0,7.647,0,15.741,0,20.806,2.45,24,6.554,24c2.954,0,5.078-1.393,8.855-7.994,0,0,1.574-2.78,2.657-4.7q.569.919,1.2,1.981l1.771,2.979c3.45,5.773,5.372,7.73,8.855,7.73,4,0,6.223-3.238,6.223-8.408C36.116,7.117,31.512,0,25.92,0M12.53,14.218c-3.062,4.8-4.121,5.876-5.826,5.876-1.754,0-2.8-1.54-2.8-4.287,0-5.876,2.93-11.884,6.422-11.884,1.891,0,3.472,1.092,5.893,4.558-2.3,3.526-3.691,5.737-3.691,5.737m11.557-.6-2.118-3.532q-.86-1.4-1.652-2.574C22.225,4.563,23.8,3.1,25.672,3.1c3.89,0,7,5.727,7,12.761,0,2.681-.878,4.237-2.7,4.237-1.744,0-2.577-1.152-5.889-6.48",
    transform: "translate(0 0)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebookIcon.855c037bc49052e047cbb59649c1d388.svg";
export { ForwardRef as ReactComponent };